import React from 'react';

interface Props {
  message?: string;
  padding?: boolean;
}

const Loading: React.FC<Props> = ({ message, padding = true }) => {
  return (
    <React.Fragment>
      <div className="loading">
        <span>
          <i className="fas fa-spinner fa-spin" />
        </span>{' '}
        {message ?? 'Loading...'}
      </div>
      <style jsx>{`
        .loading {
          font-family: 'Volvo Novum', sans-serif;
          padding: ${padding ? '20px 0' : '0'};
        }
      `}</style>
    </React.Fragment>
  );
};

export default Loading;
